import { useEffect, useState } from 'react';

import { apiOrchestrator } from 'services/apiService';

export type Team = {
  id: number | string;
  uuid: string;
  name: string;
  description: string;
};

export const useCollectiveTeams = () => {
  const [teams, setTeams] = useState<Team[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let isMounted = true;
    setIsLoading(true);
    setError(null);

    const fetchTeams = async () => {
      try {
        const response = await apiOrchestrator.get('/team/');
        if (isMounted) {
          setTeams(response.data);
        }
      } catch (err) {
        if (isMounted) setError(err as Error);
      } finally {
        if (isMounted) setIsLoading(false);
      }
    };

    fetchTeams();
    return () => {
      isMounted = false;
    };
  }, []);

  return { teams, isLoading, error };
};
